import { Prop, Component, Vue } from 'vue-property-decorator';

@Component
export default class ColumnStatus extends Vue {

    @Prop({ type: Number, default: 0, required: true }) private readonly status!: number;
    @Prop({ type: String, default: '', required: false }) private readonly description!: string;
    @Prop({ type: String, default: 'is-bottom', required: true }) private readonly position!: string;

    private types = ['is-info', 'is-success', 'is-danger'];
    private icons = ['hourglass', 'check', 'exclamation-triangle'];

    get type(): string {
        return this.status ? this.types[this.status] : this.types[0];
    }

    get icon(): string {
        return this.status ? this.icons[this.status] : this.icons[0];
    }
}